import type { MachineOperationsDetailReqType } from '@/models/types/machine.types'

export const dashboardAccountInquiryKeys = {
  all: ['dashboard-account-inquiry'] as const,
  clawOperationsDetail: (params: MachineOperationsDetailReqType, isNewApi: boolean) =>
    [...dashboardAccountInquiryKeys.all, 'claw-operations-detail', params, isNewApi] as const,
  clawGoodsRecord: (pcbId: string, isNewApi: boolean) =>
    [...dashboardAccountInquiryKeys.all, 'claw-goods-record', pcbId, isNewApi] as const,
  clawEventRecord: (params: MachineOperationsDetailReqType, isNewApi: boolean) =>
    [...dashboardAccountInquiryKeys.all, 'claw-event-record', params, isNewApi] as const,
  coinOperationsDetail: (params: MachineOperationsDetailReqType, isNewApi: boolean) =>
    [...dashboardAccountInquiryKeys.all, 'coin-operations-detail', params, isNewApi] as const,
  coinEventRecord: (params: MachineOperationsDetailReqType, isNewApi: boolean) =>
    [...dashboardAccountInquiryKeys.all, 'coin-event-record', params, isNewApi] as const
}
